import type { Branded } from "@@/utilities/branded";
import { generateId } from "@@/utilities/generate-id";
import { addDays } from "date-fns";
import type { Except } from "type-fest";
import type { IsoAndUnixTimestamp} from "../date-time/iso-and-unix";
import { nowIsoAndUnix } from "../date-time/iso-and-unix";
import type { EntityState } from "../entity-status";

type PrinterLogId = Branded<string, "PRINTER_LOG">;
type PrinterLog = {
    readonly _id: PrinterLogId;
    readonly _type: "PRINTER_LOG";

    readonly _createdAt: IsoAndUnixTimestamp;
    readonly _status: EntityState;

    readonly printerId: string;
    readonly payload: unknown;
    readonly deleteAfter: Date;
};

const printerLogFactory = (
    params: Except<
        PrinterLog,
        "_id" | "_type" | "_status" | "_createdAt" | "deleteAfter"
    >,
): PrinterLog => {
    return {
        ...params,
        _id: generateId({ prefix: "printer_log__" }),
        _type: "PRINTER_LOG",
        _status: "ACTIVE",
        _createdAt: nowIsoAndUnix(),
        printerId: params.printerId,
        payload: params.payload,
        deleteAfter: addDays(new Date(), 7),
    };
};

export { printerLogFactory };
export type { PrinterLog };
